import { render, staticRenderFns } from "./ChildIcon.vue?vue&type=template&id=df1ba876&"
import script from "./ChildIcon.vue?vue&type=script&lang=js&"
export * from "./ChildIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports